import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-confirm',
    template: `
    <h2 mat-dialog-title class="dialog-title">{{ data.title }}</h2>
    <div mat-dialog-content class="dialog-message">{{ data.message }}</div>
    <div mat-dialog-actions align="end" class="dialog-actions">
      <button mat-stroked-button type="button" class="btn-confirm-outline" (click)="dialogRef.close(false)">
        {{ data.cancelText || 'NO' }}
      </button>
      <button mat-raised-button color="primary" type="button" class="btn-confirm-primary" (click)="dialogRef.close(true)">
        {{ data.confirmText || 'SI' }}
      </button>
    </div>`,
    styles: [`
      .app-confirm-dialog .mat-mdc-dialog-container {
        border-radius: 14px;
      }

      .app-confirm-dialog .mat-mdc-dialog-surface {
        border-radius: 14px;
        padding: 22px 22px 18px;
        max-width: 560px;
        width: calc(100vw - 32px);
      }

      .app-confirm-dialog .dialog-title {
        font-size: 22px;
        line-height: 1.25;
        font-weight: 700;
        margin: 0 0 6px;
        white-space: normal;
        word-break: break-word;
        color: #111827;
      }

      .app-confirm-dialog .dialog-message {
        font-size: 14px;
        line-height: 1.45;
        margin: 0 0 10px;
        white-space: normal;
        word-break: break-word;
        color: #374151;
      }

      .app-confirm-dialog .dialog-actions {
        margin-top: 12px;
        gap: 12px;
        display: grid;
        grid-template-columns: 1fr 1fr;
      }

      .app-confirm-dialog .dialog-actions > button {
        width: 100%;
        justify-content: center;
        white-space: normal;
        height: auto;
        line-height: 1.2;
        padding-top: 10px;
        padding-bottom: 10px;
      }

      @media (max-width: 420px) {
        .app-confirm-dialog .dialog-actions {
          grid-template-columns: 1fr;
        }
      }

      .app-confirm-dialog .btn-confirm-primary.mat-mdc-raised-button {
        background: #5297ff !important;
        color: #ffffff !important;
      }

      .app-confirm-dialog .btn-confirm-outline.mat-mdc-outlined-button,
      .app-confirm-dialog .btn-confirm-outline.mat-mdc-stroked-button {
        border-color: #5297ff !important;
        color: #5297ff !important;
      }

      .app-confirm-dialog .btn-confirm-outline.mat-mdc-outlined-button:hover,
      .app-confirm-dialog .btn-confirm-outline.mat-mdc-stroked-button:hover {
        background: rgba(82, 151, 255, 0.08) !important;
      }
    `],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppComfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<AppComfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
